import { render, staticRenderFns } from "./SelectCustomerTypeModal.vue?vue&type=template&id=b0f63fb6&"
import script from "./SelectCustomerTypeModal.vue?vue&type=script&lang=js&"
export * from "./SelectCustomerTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports